<template>
    <div class="literacy_content">
        <div class="header">
            <div
                class="tab_item"
                :class="activeTabItem == item.id ? 'active_tab_item' : ''"
                v-for="item in tablist"
                :key="item.id"
                @click="clickTab(item.id)"
            >
                {{ item.name }}
            </div>
            <div class="button_box">
                <span style="margin-right: 10px; color: #ff0000">总分：{{ getScoreSum }}</span>
                <el-button size="medium" @click="goBack">返回</el-button>
                <el-button size="medium" type="primary" @click="validateForm">
                    提交评定
                </el-button>
            </div>
        </div>
        <el-scrollbar class="content">
            <div class="evaluation_list">
                <el-form :model="ruleForm" :rules="rules" ref="ruleFormRef">
                    <div class="list_item" v-for="(item, index) in ruleForm.evaluationList" :key="item.key">
                        <div class="title">
                            <span>{{ index + 1 }}、{{ item.name }}</span>
                        </div>
                        <div class="data_box">
                            <div class="data_list" v-for="(childItem, childIndex) in item.chirldren" :key="childItem.key">
                                <span class="name">{{ childItem.name }}</span>

                                <el-form-item :rules="rules.score" :prop="`evaluationList[${index}].chirldren[${childIndex}].score`">
                                    <el-input-number
                                        placeholder="0-5"
                                        :precision="0"
                                        v-model="childItem.score"
                                        :max="5"
                                        :controls="false"
                                        class="pw-input"
                                        style="width: 375px"
                                    >
                                    </el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name: "teacherMatingDetail",
    data() {
        return {
            tablist: [{ name: "学员素养评定", id: 1 }],
            activeTabItem: 1,
            ruleForm: {
                evaluationList: [],
            },
            rules: {
                score: { required: true, message: "请输入细则分数", trigger: "blur" },
            },
        };
    },
    components: {},
    computed: {
        getScoreSum() {
            let score = 0;

            this.ruleForm.evaluationList.forEach((evaluation) => {
                if (evaluation.chirldren && evaluation.chirldren.length > 0) {
                    evaluation.chirldren.forEach((item) => {
                        const itemScore = Number(item.score);
                        if (!isNaN(itemScore)) score += itemScore;
                    });
                }
            });

            return score;
        },
    },
    methods: {
        clickTab(id) {},

        getLiteracyAssmentList() {
            const params = {
                c_id: Number(localStorage.getItem("class_id")),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(localStorage.getItem("teacherChapter")),
                course_node: Number(localStorage.getItem("teacherNode")),
                s_id: Number(this.$route.query.s_id),
            };

            this.$shttp.axiosGetBy(this.$api.literacy_score_detail, params, (res) => {
                if (res.code === 200) {
                    this.ruleForm.evaluationList = res.data.list || [];

                    this.ruleForm.evaluationList.forEach((item) => {
                        item.chirldren.forEach((childItem) => {
                            if (childItem.score === "") childItem.score = undefined;
                        });
                    });
                }
            });
        },

        goBack() {
            this.$router.push({
                path: "/qualityCourse/teacher/literacyEvaluation",
                query: {
                    course_id: this.$route.query.course_id,
                },
            });
        },

        validateForm() {
            this.$refs.ruleFormRef.validate((valid) => {
                if (valid) {
                    this.submit();
                } else {
                    console.error("error submit!!");
                }
            });
        },

        submit() {
            const params = {
                c_id: Number(localStorage.getItem("class_id")),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(localStorage.getItem("teacherChapter")),
                course_node: Number(localStorage.getItem("teacherNode")),
                s_id: Number(this.$route.query.s_id),
                content: [],
            };
            this.ruleForm.evaluationList.forEach((item) => {
                item.chirldren?.forEach((childItem) => {
                    params.content.push({
                        key: childItem.key,
                        score: childItem.score,
                    });
                });
            });

            this.$shttp.axiosPost(this.$api.literacy_score, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);

                    this.goBack();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
    mounted() {
        this.getLiteracyAssmentList();
    },
};
</script>

<style scoped lang="scss">
.literacy_content {
    width: 100%;
    height: 100%;
    background-color: #ffffff;

    .header {
        width: 100%;
        padding: 0 44px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        justify-content: space-between;
        box-sizing: border-box;

        .tab_item {
            padding: 18px 0;
            margin-right: 46px;
            border-bottom: 2px solid transparent;
            cursor: pointer;
        }

        .active_tab_item {
            color: #006eff;
            border-bottom: 2px solid #006eff;
        }
    }
    .content {
        width: 100%;
        height: calc(100vh - 212px);
        padding: 20px 44px;
        box-sizing: border-box;

        ::v-deep .el-scrollbar__wrap::-webkit-scrollbar {
            display: none;
        }

        .evaluation_list {
            height: 100%;
            padding: 20px 30px;
            background: #f2f6fa;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #ededed;

            .list_item {
                .title {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 20px;
                    color: #333333;
                    line-height: 23px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    padding: 20px 0;
                }

                .data_box {
                    padding: 0 20px;

                    .data_list {
                        padding: 5px 0 12px 0;
                        display: flex;
                        align-items: center;

                        .name {
                            width: 180px;
                            display: flex;
                            justify-content: end;
                            margin-right: 20px;
                        }

                        .el-form-item {
                            margin-bottom: 0px;
                        }
                    }
                }
            }
        }
    }
}
::v-deep .el-input-number .el-input__inner {
    text-align: left;
}
</style>
